<template>
  <div class="modal fade" id="bulk-update-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-info-circle mr-5"></i>Massenupdate</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <h4 class="text-danger">Von dieser Änderung sind {{storeCount}} Filialen betroffen</h4>
              <div class="col-xs-12 mt-10" v-for="(value, key) in bulkChannels" v-if="key !== 'spartoo'">
                <div class="col-xs-4">
                  <span v-if="key === 'ti_sale_window'">
                    <img class="img-responsive img-channel mb-10" :src="'/static/img/schuhede.svg'">
                  </span>
                  <span v-else-if="key === 'ti_mp_diverse'">
                    <img class="img-responsive img-channel mb-10" :src="'/static/img/schuhede-spartoo.svg'">
                  </span>
                  <span v-else-if="key === 'mirapodo'">
                    <img class="img-responsive img-channel mb-10" :src="'/static/img/mirapodo.svg'">
                  </span>
                  <span v-else-if="key === 'ti_reserve_window'">
                    Click&Collect
                  </span>
                  <span v-else>
                    <img class="img-responsive img-channel mb-10" :src="'/static/img/schuhede-' + key + '.svg'">
                  </span>
                </div>
                <div class="col-xs-8">
                  <div class="btn-group pb-10" data-toggle="btn-toggle">
                    <button type="button" @click="updateChannelStatus(key, 1)" class="btn btn-success"><i class="fa fa-check mr-5"></i>{{'is_active' | translate}}</button>
                    <button type="button" @click="updateChannelStatus(key, 0)" class="btn btn-danger"><i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}</button>
                    <button type="button" @click="updateChannelStatus(key, 2)" class="btn btn-info active">{{'no_selection' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <b-btn @click="sendBulk" data-dismiss="modal" type="button" class="btn btn btn-sm btn-success ml-5 pull-left"><i class="fa fa-undo mr-5"></i>{{'apply' | translate}}</b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['companyId', 'branches', 'storeCount'],
    data () {
      return {
        updateChannels: {},
        bulkChannels: {
          amazon: 1,
          check24: 1,
          ebay: 1,
          goertz: 1,
          mirapodo: 1,
          spartoo: 1,
          zalando: 1,
          ti_reserve_window: 1,
          ti_sale_window: 1,
          ti_mp_diverse: 1,
          gaxsys: 1,
          tamaris: 1,
          marco_tozzi: 1,
          legero: 1,
          caprice: 1,
          limango_de: 1,
          kaufland_de: 1
        },
        alerts: []
      }
    },
    methods: {
      sendBulk () {
        this.$emit('loadBulkUpdate', {stores: this.branches, bulkChannels: this.updateChannels})
      },
      updateChannelStatus (key, status) {
        if (status !== 2) {
          this.updateChannels[key] = status
        }
        this.bulkChannels[key] = status
      },
    },
    mounted () {
      this.$nextTick(function () {
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/Modals/BulkUpdateModal.vue